import { render } from "./FamiliaHistorico.vue?vue&type=template&id=487a9efa&ts=true"
import script from "./FamiliaHistorico.vue?vue&type=script&lang=ts"
export * from "./FamiliaHistorico.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__